export { default as BooleanDisplay } from './BooleanDisplay';
export type { BooleanDisplayProps } from './BooleanDisplay';
